<template>
  <div class="wrapper-card">
    <div class="card col-md-6">
        <h3>Expunerea la mediul înconjurător</h3>
        <p>trebuie să se facă treptat astfel încât organismul să se acomodeze cu factorii de mediu.
        </p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Expunerea',

    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">
.bk-blue-light {
    background: #F2F0ED;
    border-radius: 20px;
    width: 458px !important;
    min-height: 200px;
    max-height: 200px;
    position: relative;
    @media only screen and (max-width: 992px) {
        width: 100% !important;
        min-height: 100%;
        max-height: 100%;
        margin-top: 15px;
    }

    &:focus {
        outline: none;
    }

    h3 {
        font-size: 20px;
        font-weight: 700;
        color: #029FE3;
    }

    p {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
    }

    span {
        font-size: 16px;
        font-weight: 500;
        color: #029FE3;
    }
}
</style>
